import { useState } from 'react';
import { ordersApi } from '../../api/orders';

export function OrderImportPage() {
  const [marketplaceOrderID, setMarketplaceOrderID] = useState('');
  const [productID, setProductID] = useState('');
  const [title, setTitle] = useState('');
  const [quantity, setQuantity] = useState('1');
  const [unitPrice, setUnitPrice] = useState('');
  const [source, setSource] = useState('amazon_spapi');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    try {
      const o = await ordersApi.import({
        source, marketplace_order_id: marketplaceOrderID, currency: 'INR',
        items: [{ product_id: productID, title, quantity: parseFloat(quantity), unit_price: parseFloat(unitPrice) }],
      });
      setMessage(`Imported order ${o.order_number}`);
    } catch (err) {
      setError(String(err));
    }
  }

  return (
    <div className="mx-auto max-w-lg p-6">
      <h1 className="text-2xl font-semibold">Import Marketplace Order</h1>
      <form className="mt-6 space-y-4" onSubmit={(e) => void submit(e)}>
        <select className="w-full rounded border p-2" value={source} onChange={(e) => setSource(e.target.value)}>
          <option value="amazon_spapi">Amazon</option>
          <option value="flipkart">Flipkart</option>
          <option value="shopify">Shopify</option>
        </select>
        <input className="w-full rounded border p-2" placeholder="Marketplace order ID" value={marketplaceOrderID} onChange={(e) => setMarketplaceOrderID(e.target.value)} required />
        <input className="w-full rounded border p-2" placeholder="Product ID" value={productID} onChange={(e) => setProductID(e.target.value)} required />
        <input className="w-full rounded border p-2" placeholder="Title" value={title} onChange={(e) => setTitle(e.target.value)} required />
        <input className="w-full rounded border p-2" placeholder="Quantity" value={quantity} onChange={(e) => setQuantity(e.target.value)} required />
        <input className="w-full rounded border p-2" placeholder="Unit price" value={unitPrice} onChange={(e) => setUnitPrice(e.target.value)} required />
        <button type="submit" className="rounded bg-slate-900 px-4 py-2 text-white">Import</button>
      </form>
      {message && <p className="mt-4 text-sm text-green-600">{message}</p>}
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
    </div>
  );
}
